module.exports = __webpack_public_path__ + "img/teaser_training12.5086ef59.jpg";